module.exports = __webpack_public_path__ + "static/media/img-45b69ce7.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/gif/h-chrome-1.gif
// module id = 5268
// module chunks = 39